<Section>

  <kendo-grid [data]="manageProductGridView" [height]="470" [sortable]="true" [navigable]="true"
              [filterable]="true" [groupable]="false" [reorderable]="true" [resizable]="false" [columnMenu]="false"
              [pageSize]="productGridState.take" [skip]="productGridState.skip" (sortChange)="productGridSortChange($event)"
              [pageable]="{ buttonCount: 5, info: true }" [sort]="productGridState.sort" [filter]="productGridState.filter"
              (pageChange)="productGridPageChange($event)" (dataStateChange)="productGridDataStateChange($event)"
              [loading]="productLoading">


    <kendo-grid-column field="id" title="Id" [columnMenu]="false" [filterable]="true"
                       [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" let-dataItem>
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <!--<kendo-grid-column field="publishedName" title="Published Name" [columnMenu]="false" [filterable]="true"
                     [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>-->

    <kendo-grid-column field="productCode" title="Product Code" [columnMenu]="false" [filterable]="true"
                       [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="name" title="Product Description" [columnMenu]="false" [filterable]="true"
                       [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="type" title="Product Type" [columnMenu]="false" [filterable]="true"
                       [editable]="false">
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
          <kendo-filter-contains-operator></kendo-filter-contains-operator>
        </kendo-grid-string-filter-cell>
      </ng-template>
    </kendo-grid-column>
    <!--<kendo-grid-column field="templateDescription" title="Template Description" [columnMenu]="false" [filterable]="true"
                     [editable]="false">
    <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
      <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
        <kendo-filter-contains-operator></kendo-filter-contains-operator>
      </kendo-grid-string-filter-cell>
    </ng-template>
  </kendo-grid-column>-->
    <kendo-grid-command-column field="" title="" [width]="230">
      <ng-template kendoGridCellTemplate let-dataItem>
        <!--Need to change the button-->
        <button title="edit" (click)="editProduct(dataItem,'/configProduct/createConfiguration')" kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls">
          <span class=" k-icon k-i-edit k-i-pencil"></span>
        </button>
        <button title="copy" (click)="copyProduct(dataItem,'/configPoduct/createConfiguration')" kendoButton class="m-2 clearKendoButton btn btn-success btnSizeCls">
          <span class=" k-icon k-icon k-i-copy"></span>
        </button>

        <button class="k-button k-grid-remove-command " (click)="removeConfirmation(dataItem)">
          <span class="k-icon k-i-trash">
          </span>
        </button>
      </ng-template>
    </kendo-grid-command-column>
    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
    </ng-template>
  </kendo-grid>
  <div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row">
    <button (click)="createProduct('/configProduct/createConfiguration')"  [icon]="'plus'" class="m-3 clearKendoButton btn btn-success"
            kendoButton>
      Add New Product
    </button>

  </div>
</Section>
<kendo-dialog title="{{gridDelete.label.confirmLbl?gridDelete.label.confirmLbl:gridDelete.label.confirmLbl}}" *ngIf="gridItemToRemove" (close)="confirmRemove(false)">
  <p style="margin: 30px; text-align: center;">
    {{gridDelete.label.deleteConfirmLbl?gridDelete.label.deleteConfirmLbl:gridDelete.label.deleteConfirmLbl}}
    <b> : {{ gridItemToRemove.name }}</b>?
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="confirmRemove(false)">
      {{gridDelete.label.deleteNoLbl?gridDelete.label.deleteNoLbl:gridDelete.label.deleteNoLbl}}
    </button>
    <button class='k-button k-primary' (click)="confirmRemove(true)" primary="true">
      {{gridDelete.label.deleteYesLbl?gridDelete.label.deleteYesLbl:gridDelete.label.deleteYesLbl}}
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
